export default {
  name: '1.43.0',
  sha: '',
};